import {ApiService, InGameChallengesController_ClaimTicketResponse, InGameChallengesController_GetTicketPrizesResponse} from "../api/api.service";
import {IUserTicket} from "../firebase/topics/in-game-challenges/tickets-update/user-tickets-update-topic.model.interface";
import {ILoggerService} from "../logger/logger.service.interface";

type TicketPrizesResponseData = InGameChallengesController_GetTicketPrizesResponse["data"];
type ClaimTicketResponseData = InGameChallengesController_ClaimTicketResponse["data"];

function waitFor(time: number) {
    return new Promise<void>((res) => {
        setTimeout(() => { res(); }, time)
    })
}

export class TicketModel {
    private prizesPromise: Promise<TicketPrizesResponseData> | null = null;
    private actualPrizePromise: Promise<ClaimTicketResponseData> | null = null;
    public claimed = false;

    constructor(public readonly ticketData: IUserTicket, private api: ApiService, private logger: ILoggerService) {}

    async getPrizes() {
        if (this.prizesPromise) {
            return this.prizesPromise;
        }
        this.prizesPromise = this.fetchPrizes();
    }

    private _isExpired = this.checkExpiration();
    get isExpired(): boolean {
        if (this._isExpired) {
            return this._isExpired;
        }
        this._isExpired = this.checkExpiration();
        return this._isExpired;
    }

    private async fetchPrizes(retry: boolean = false, retryInterval: number = 1000): Promise<TicketPrizesResponseData> {
        try {
            let response = await this.api.inGameChallengesController.getTicketPrizes({promotionId: this.ticketData.promotionId});
            if (response.hasError) {
                const errorMsg = `InGame Challenge: ticket prizes fetch errored: ` + JSON.stringify({
                    errorCode: response.errorCode,
                    errorDescription: response.errorDescription,
                    errorDetails: response.errorDetails
                });
                this.logger.debug(errorMsg);
                throw new Error(errorMsg);
            } else {
                return response.data;
            }
        } catch (e) {
            if (retry) {
                await waitFor(retryInterval);
                return await this.fetchPrizes();
            } else {
                throw e;
            }
        }
    }

    private checkExpiration() {
        const currentDate = new Date();
        const expirationDate = new Date(this.ticketData.expirationDate);

        return currentDate > expirationDate
    }

    public async claimTicket(retry: boolean = false, retryInterval: number = 1000): Promise<ClaimTicketResponseData> {
        try {
            let response = await this.api.inGameChallengesController.claimTicket({
                ticketId: this.ticketData.ticketId
            });
            if (response.hasError) {
                const errorMsg = `InGame Challenge: ticket prizes fetch errored: ` + JSON.stringify({
                    errorCode: response.errorCode,
                    errorDescription: response.errorDescription,
                    errorDetails: response.errorDetails
                });
                this.logger.debug(errorMsg);
                throw new Error(errorMsg);
            } else {
                this.claimed = true;
                return response.data;
            }
        } catch (e) {
            if (retry) {
                await waitFor(retryInterval);
                return await this.claimTicket();
            } else {
                throw e;
            }
        }
    }

}
